import React from "react";

const ExpensesSkeleton = () => (
  <div className="h-full bg-gray-50">
    {/* Top Navigation Bar Skeleton */}
    <div className="bg-gray-200 p-4">
      <div className="animate-pulse flex items-center space-x-8">
        {[...Array(2)].map((_, idx) => (
          <div key={idx} className="flex items-center space-x-2">
            <div className="w-5 h-5 bg-gray-300 rounded"></div>
            <div className="h-4 bg-gray-300 rounded w-20"></div>
          </div>
        ))}
      </div>
    </div>

    <div className="p-6 space-y-6">
      {/* Summary Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[...Array(3)].map((_, idx) => (
          <div key={idx} className="bg-white rounded-lg border border-gray-300 p-4">
            <div className="animate-pulse">
              <div className="flex items-center justify-between mb-3">
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                <div className="w-8 h-8 bg-gray-200 rounded-lg"></div>
              </div>
              <div className="h-8 bg-gray-200 rounded w-3/4 mb-2"></div>
              <div className="h-3 bg-gray-200 rounded w-2/3"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Expense Records Section */}
      <div className="bg-white rounded-lg border border-gray-300 p-6">
        <div className="animate-pulse">
          {/* Header Section */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-2">
              <div className="h-6 bg-gray-200 rounded w-32"></div>
              <div className="h-4 bg-gray-200 rounded w-24"></div>
            </div>
          </div>

          {/* Action Bar/Filters */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-4">
              <div className="h-10 bg-gray-200 rounded w-24"></div>
              <div className="flex items-center gap-2">
                {[...Array(4)].map((_, idx) => (
                  <div key={idx} className="h-8 bg-gray-200 rounded w-16"></div>
                ))}
              </div>
              <div className="flex items-center gap-2">
                <div className="h-8 bg-gray-200 rounded w-4"></div>
                <div className="h-4 bg-gray-200 rounded w-32"></div>
                <div className="h-8 bg-gray-200 rounded w-4"></div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-8 bg-gray-200 rounded w-48"></div>
              <div className="w-8 h-8 bg-gray-200 rounded"></div>
            </div>
          </div>

          {/* Expense Records Table */}
          <div className="space-y-3">
            {/* Table Header */}
            <div className="grid grid-cols-5 gap-4 py-3 border-b border-gray-300">
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
            </div>

            {/* Table Rows */}
            {[...Array(8)].map((_, rowIdx) => (
              <div key={rowIdx} className="grid grid-cols-5 gap-4 py-4 border-b border-gray-200">
                {/* Expense Details Column */}
                <div className="space-y-1">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                </div>
                
                {/* Amount Column */}
                <div className="flex items-center">
                  <div className="h-4 bg-gray-200 rounded w-16"></div>
                </div>
                
                {/* Payment Method Column */}
                <div className="flex items-center">
                  <div className="h-4 bg-gray-200 rounded w-12"></div>
                </div>
                
                {/* Date Column */}
                <div className="flex items-center">
                  <div className="h-4 bg-gray-200 rounded w-20"></div>
                </div>
                
                {/* Status and Actions Column */}
                <div className="flex items-center justify-between">
                  <div className="h-6 bg-gray-200 rounded-full w-16"></div>
                  <div className="flex items-center gap-2">
                    <div className="w-5 h-5 bg-gray-200 rounded"></div>
                    <div className="w-5 h-5 bg-gray-200 rounded"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex items-center justify-between mt-6 pt-4 border-t border-gray-300">
            <div className="h-4 bg-gray-200 rounded w-32"></div>
            <div className="flex items-center gap-2">
              <div className="h-8 bg-gray-200 rounded w-8"></div>
              <div className="h-8 bg-gray-200 rounded w-8"></div>
              <div className="h-8 bg-gray-200 rounded w-8"></div>
              <div className="h-8 bg-gray-200 rounded w-8"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ExpensesLoader = ({ isLoading, children }) => {
  if (isLoading) {
    return <ExpensesSkeleton />;
  }
  return children;
};

export default ExpensesLoader;
